import { render, staticRenderFns } from "./exportyunxing.vue?vue&type=template&id=24ef95b2&scoped=true"
import script from "./exportyunxing.vue?vue&type=script&lang=js"
export * from "./exportyunxing.vue?vue&type=script&lang=js"
import style0 from "./exportyunxing.vue?vue&type=style&index=0&id=24ef95b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef95b2",
  null
  
)

export default component.exports